import {
  useMutation,
  useQuery,
  UseQueryOptions,
  UseMutationOptions,
  QueryKey,
} from "@tanstack/react-query";
import axios, { AxiosRequestConfig, Method } from "axios";

const API_KEY =
  "1155fff2f80fc45eda33e8bde788f500a7bb2044e9bcbe339a3c36e417b22baa";

// Fetch Query Hook
export const useFetchQuery = <T, E = unknown>(
  url: string,
  queryKey: QueryKey,
  params?: Record<string, any>,
  options?: UseQueryOptions<T, E, T>
) => {
  const queryFn = async (): Promise<T> => {
    const queryString = params
      ? new URLSearchParams(
          Object.fromEntries(
            Object.entries(params).map(([key, value]) => [key, String(value)])
          )
        ).toString()
      : "";
    const fullUrl = queryString ? `${url}?${queryString}` : url; // Fixed template literal

    const response = await axios.get<T>(fullUrl, {
      headers: {
        "x-api-key": API_KEY,
      },
    });

    return response.data;
  };

  return useQuery<T, E>({ queryKey, queryFn, ...options });
};

// Mutation Hook
export const useMutate = <T, D = unknown, E = unknown>(
  url: string,
  method: Method = "post",
  options?: UseMutationOptions<T, E, D>
) => {
  const mutationFn = async (data: D): Promise<T> => {
    const config: AxiosRequestConfig = {
      method,
      url,
      data,
      headers: {
        "x-api-key": API_KEY,
      },
      timeout: 5000,
    };

    const response = await axios<T>(config);
    return response.data;
  };

  return useMutation<T, E, D>({ mutationFn, ...options });
};
